import { TweenLite } from "gsap";
import { LogGroup, Log, Scale, Size, CreateElement } from "./MyHelpers";
import { MoneyFormatter } from "./MoneyFormatter";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { MyCanvas, MyCanvasContext } from "./slot/MyCanvas";
import { JackPotTextParams } from "./JackPotTextParams";
import { service } from "./services";
export class JackpotText
{
    protected logGroup: LogGroup;
   // protected canvas: HTMLCanvasElement = null;
    //protected ctx:CanvasRenderingContext2D = null;
    protected canvas: MyCanvas;
    protected ctx: MyCanvasContext;
    //protected view:HTMLElement = null;

    protected numberWidth: number = 0;
    protected numberHeight: number = 0;
    protected textSpaceFactor: number = 1.15;

    public fontHeight: number; 

    public start:number = null;

    protected width: number;
    protected height: number;
    protected moneyFormatter: MoneyFormatter;

    protected color: string = "black";
    protected color2: string = "black";
    protected colorMiddle : string = "black";
   
    protected font: string ;

    protected view: HTMLElement = null;

    protected started: boolean = false;
    protected stroke :boolean = false;
    protected bold: boolean = false ;
    protected fontStyle: string =  "";
    protected colorStroke: string = "black";


    constructor(params: JackPotTextParams){

        this.logGroup = params.logGroup;
        this.width = params.width;
        this.height = params.height;
        this.color = params.color;
        this.color2 = params.color2;
        this.colorMiddle = params.colorMidle != null ? params.colorMidle : params.color2;
        
        this.font = params.font;

         this.moneyFormatter = service.moneyFormatter

         

        //this.moneyFormatter = params.moneyFormatter;

        this.fontHeight = params.height;
        if(params.stroke != null){
        this.stroke = params.stroke;
        }//lo mismo aqui si no deffines stroke en paso de params tienes que utilizar el default
        if(params.bold != null && params.bold == true){
            this.fontStyle = "bold ";
        }
        //esto en teoria si tiene algo lo guarda si no no y tiene que usar el default 
        if(params.colorStroke != null){
        this.colorStroke = params.colorStroke;
        }



       this.currentValue = params.defaultValue;
       this.currentValueFormatted = this.moneyFormatter.FormatCurrencyEmptySymbol(params.defaultValue);
       this.currentDigits = this.NumberToDigits(params.defaultValue);

       this.targetValue = params.defaultValue;
       this.targetValueFormatted = this.moneyFormatter.FormatCurrencyEmptySymbol(params.defaultValue);
       this.targetDigits = this.NumberToDigits(params.defaultValue);

       

       this.view = document.createElement("div");
       this.view.style.width = params.width + "px";
       this.view.style.height = params.height + "px";
    }


    protected starTime: number = 0;

    public Start(): void
    {
        if (!this.started)
        {
            this.started = true;
            this.MeasureTargetValueText();
        }
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {

    }

    protected CreateFontType(){
        this.ctx.font = this.fontStyle  + this.fontHeight + "px " + this.font;
    }
    // context can reset (get lost), so we need to apply the styles again
    protected SetContextProperties()
    {
        //Yo
        //this.canvas.context.font = "bold " + this.fontHeight + "px " + this.font;

        const gradient = this.canvas.context.createLinearGradient(0, 0, 0, this.canvas.Canvas().height);
        gradient.addColorStop(0, this.color);
        gradient.addColorStop(0.25, this.color2);
        gradient.addColorStop(0.50, this.colorMiddle);         
        gradient.addColorStop(0.75, this.color2);
        gradient.addColorStop(1, this.color);

        this.ctx.fillStyle = gradient;
        this.ctx.shadowColor="black";
        this.ctx.shadowOffsetX = 1;
        this.ctx.shadowOffsetY = 0;
        this.ctx.shadowBlur = 0;
        this.ctx.lineJoin = "round";
        this.ctx.textBaseline = "middle";
        //this.ctx.fillRect(0 , 0 , this.canvas.size.width , this.canvas.size.height);

	  
		// correction?
        //this.fontHeight = this.fontHeight - Scale.H(25);
        //Yo
        //this.ctx.font = "bold " + this.fontHeight + "px " + this.font;
        this.CreateFontType();
    }

    public ResourcesLoaded()
    {


        this.canvas = new MyCanvas(new Size(this.width, this.height));
        this.ctx = this.canvas.context;

        this.SetContextProperties();

        // premeasure numbers
        let maxNumerHeight: number = 0;
        for (let i = 0; i < 10; i++) {
            
            let metrics: TextMetrics = this.ctx.measureText("" + i);
            let width = metrics.width;
            //// Log.Debug(this.logGroup, "Measuring " + i + ": " + width + "px");
            if (width > this.numberWidth)
                this.numberWidth = width;
            //if (metrics.fontBoundingBoxAscent > this.numberHeight) this.numberHeight = metrics.fontBoundingBoxAscent;
        }

        //// Log.Debug(this.logGroup, "Max number width: " + this.numberWidth);

        this.numberHeight =  this.fontHeight;
      
        
        this.view.appendChild(this.canvas.Canvas());
    }


    protected currentValue: number = 0;
    protected targetValue: number = 0;

    protected currentValueFormatted: string = "0";
    protected targetValueFormatted: string = "0";
    protected digitAnim: TweenLite[] = [];

    protected currentDigits: number[] = this.NumberToDigits(this.currentValue);
    protected targetDigits: number[] = this.NumberToDigits(this.targetValue);

    protected animation: TweenLite = null;

    protected meausredTargetValue: string = "";
    protected targetValueTextWidth: number = 0;

    public SetTarget(newTarget: number)
    {
       

        if (newTarget != this.targetValue)
        {
            this.animating = true;
        }

        this.targetValue = newTarget;
        this.targetValueFormatted = this.moneyFormatter.FormatCurrencyEmptySymbol(this.targetValue);
        //this.targetValueFormatted=this.targetValueFormatted.replace(/([^0-9]+)/, "$1  ");
        this.targetDigits = this.NumberToDigits(this.targetValue);

        //console.log("targetValueFormatted: ", this.targetValueFormatted)
        

        // create anims for each digit
        for (let i = 0; i < this.targetDigits.length; i++)
        {
            // prefix zeros, if current digit is shorter than target digit
            if (this.currentDigits.length < i+1)
            {
                this.currentDigits[i] = 0;
            }


            // create new animation for changed digits
            if (this.currentDigits[i] != this.targetDigits[i])
            {

              
                // stop previous anim
                if (this.digitAnim[i] != null) this.digitAnim[i].kill();



                // make sure to always count up
                this.currentDigits[i] = this.currentDigits[i] % 10;
                if (this.targetDigits[i] < this.currentDigits[i]) this.targetDigits[i] += 10;

                // count in currentDigits array
                let animObject = {value: this.currentDigits[i]};

                // limit minimum speed
                let defaultDuration = 15;
                let duration = defaultDuration;
        
                let speed = (this.targetDigits[i] - this.currentDigits[i]) / defaultDuration;
        
                let minSpeed = 1;
                if (speed < minSpeed)
                {
                    speed = minSpeed;
                    duration = (this.targetDigits[i] - this.currentDigits[i]) / speed;
                }

                this.digitAnim[i] = TweenLite.to(animObject, duration, {value: this.targetDigits[i], onUpdate: () => { this.currentDigits[i] = animObject.value }, onComplete: () => this.CheckAnimationFinished() });
                
                this.animationFinished = false;
            }
        }


        this.MeasureTargetValueText();
    }

    protected animationFinished: boolean = true;
    protected animating: boolean = false;

    protected CheckAnimationFinished()
    {
        this.animationFinished = true;
        for (let i = 0; i < this.digitAnim.length; i++)
        {
            if (this.digitAnim[i] == null || this.digitAnim[i].progress() == 1)
            {

            }
            else
            {
                this.animationFinished = false;
                break;
            }
        }
    }

    protected MeasureTargetValueText(): void
    {
        // measure text width
        if (this.started)
        {
            if (this.meausredTargetValue != this.targetValueFormatted)
            {
                this.targetValueTextWidth = 0;
                for (let i = 0; i < this.targetValueFormatted.length; i++)
                {
                    if (this.targetValueFormatted[i] >= '0' && this.targetValueFormatted[i] <= '9')
                    {
                        this.targetValueTextWidth += this.numberWidth;
                    }
                    else
                    {
                        this.targetValueTextWidth += this.ctx.measureText(this.targetValueFormatted[i]).width;
                    }
                }

                this.meausredTargetValue = this.targetValueFormatted;
            }
        }
    }

    // need at least 3 digits;
    public NumberToDigits(n: number): number[]
    {
        let result: number[] = [];

        n = Math.ceil(n);
        do
        {
            let digit = n % 10;
            result.push(digit);

            n = Math.floor(n / 10);
        }
        while (n > 0 || result.length < 3);

        return result;

    }


    public JackpotStroke(ctx: MyCanvasContext, NumberJackpot: number, x: number, y: number)
    {
        //this.ctx.strokeStyle="black";
        //this.ctx.lineWidth = 10;
        //this.ctx.strokeText("" + NumberJackpot, x, y );
        
        this.ctx.strokeStyle = this.colorStroke;
        this.ctx.lineWidth = Scale.W(5);
        this.ctx.strokeText("" + NumberJackpot, x, y );
        

    }

    public StrokeAllText(ctx: MyCanvasContext, Text: string, x: number, y: number)
    {
        //this.ctx.strokeStyle="black";
        //this.ctx.lineWidth = 10;
        //this.ctx.strokeText("" + Text, x, y );
        this.ctx.strokeStyle = this.colorStroke;
        this.ctx.lineWidth = Scale.W(5) ;
        this.ctx.strokeText("" + Text, x, y );
        
    }

    public Draw(force: boolean = false):void
    {
        if (!this.started) return;

        let contextLost = this.canvas?.WasContextLost();
        if (!this.animating && !contextLost) return;

        if (contextLost)
        {
            this.SetContextProperties();
        }
        this.ctx.clearRect(0,0,this.canvas.size.Width,this.canvas.size.Height);
        this.ctx.save();

        let y = 0;
        let x = ((this.width - this.targetValueTextWidth) / 2) + (this.targetValueTextWidth);// - this.maxWidth);


        let formatedIndex = this.targetValueFormatted.length -1 -1;

        this.ctx.beginPath();
        this.ctx.rect((this.width - this.targetValueTextWidth) / 2, y, this.targetValueTextWidth, this.fontHeight);

        for (let i = 0; i < this.targetDigits.length; i++)
        {
            x -= this.numberWidth;
            this.ctx.save();

            
            let offset = this.currentDigits[i] % 1;
            
            this.ctx.beginPath();
            this.ctx.rect(x -2, y, this.numberWidth +4, this.numberHeight +4);
            //this.ctx.stroke();

            // prevent drawing number outside of rectangle
            this.ctx.clip();

            

            // draw top digit
            let topDigit = 0;
            if (!isNaN(this.currentDigits[i]))
            {
                topDigit = Math.floor(this.currentDigits[i]) % 10;

                if(this.stroke == true){
                    this.JackpotStroke(this.ctx,topDigit,x+2,(this.height/2) - (this.numberHeight * offset) );
                }

                this.ctx.fillText("" + topDigit, x+2, (this.height/2) - (this.numberHeight * offset));
            }
            
            // draw bottom digit
            if (offset > 0.001)
            {
                let bottomDigit = (topDigit +1) % 10;


                if(this.stroke == true){
                    this.JackpotStroke(this.ctx,bottomDigit,x+2,((this.height/2) + this.numberHeight )- (this.numberHeight * offset));
                }

                this.ctx.fillText("" + bottomDigit, x+2, ((this.height/2)+ this.numberHeight) - (this.numberHeight * offset));
            }

            this.ctx.restore();


            this.ctx.save();

            // draw everything that's not a digit
            for (; formatedIndex >= 0; formatedIndex--)
            {


                

                // if it's not digit, display it
                if (this.targetValueFormatted[formatedIndex] < '0' || this.targetValueFormatted[formatedIndex] > '9')
                {
                    let w: number = this.ctx.measureText(this.targetValueFormatted[formatedIndex]).width;
                    x -= w;
                                       
                    if (this.targetValueFormatted[formatedIndex] == '.' ||this.targetValueFormatted[formatedIndex] == ',')
                    {
                        
                        //this.ctx.textBaseline = "top"; 
                        this.ctx.textAlign="left";
                    }
                    else
                    {
                        //FIZ THIS FOR MARKO EXAMPLE´S
                        //this.ctx.font = "bold " + (this.fontHeight/1.7) + "px " + this.font;
                        //this.ctx.textBaseline = "top"; 
                        //this.ctx.translate(13,11);
                        //this.StrokeAllText( this.ctx ,this.targetValueFormatted[formatedIndex],x,y);
                        
                    }
                    
                    if(this.stroke == true){
                        this.StrokeAllText( this.ctx ,this.targetValueFormatted[formatedIndex],x+1,(this.height/2));
                    }

                
                    this.ctx.fillText(this.targetValueFormatted[formatedIndex], x+1, (this.height/2));
                    // this.ctx.font = "bold " + this.fontHeight + "px " + this.font;
                    // this.CreateFontType();

                    //this.ctx.beginPath();
                    //this.ctx.rect(x, y, w, this.fontHeight);
                    //this.ctx.stroke();
                }
                

                // digit, break
                else
                {
                    formatedIndex--;
                    break;
                }

                
                
            }

            this.ctx.restore();
        }

        this.ctx.restore();

        if (this.animationFinished) this.animating = false;
        if (contextLost) this.canvas.RestoreContext();
    }

    public View():HTMLElement
    {
        return this.view;
    }


    public CanvasView(){
        return this.canvas
    }

}

